import React, { useState } from 'react';
import { toast } from 'sonner';
import { PixCheckoutModal } from '../payments/PixCheckoutModal';
import '../../styles/home.css';

// Pacotes — marcação EXATA da página modelo (sem ícones, bullets simples,
// botões .btn/.ghost; checkout Pix real na fase 2 — Pré-Pago sem preço segue com toast)
const PACKAGES = [
  {
    id: 'consumo',
    name: 'Pré-Pago',
    cr: 'à vista',
    per: 'pague só o que usar',
    features: ['1 crédito = 1 conversa', 'Créditos não expiram', 'Sem compromisso'],
  },
  {
    id: 'basic',
    name: 'Básico',
    cr: 'R$ 29,90',
    per: '100 créditos',
    features: ['Chat astral', 'Horóscopo diário', 'Biorritmo completo'],
  },
  {
    id: 'plus',
    name: 'Plus',
    cr: 'R$ 69,90',
    per: '300 créditos',
    featured: true,
    features: ['Tudo do Básico', 'Mapa astral completo', 'Sinastria ilimitada'],
  },
  {
    id: 'premium',
    name: 'Premium',
    cr: 'R$ 99,90',
    per: '500 créditos',
    features: ['Tudo do Plus', 'Consultas prioritárias', 'Tarot ilimitado'],
  },
];

export const CreditPackagesCarousel: React.FC = () => {
  const [checkoutPkg, setCheckoutPkg] = useState<string | null>(null);
  return (
    <>
      <div className="plan-grid">
      {PACKAGES.map((pkg) => (
        <div key={pkg.id} className={`plan${pkg.featured ? ' hl' : ''}`}>
          <b>{pkg.name}</b>
          <div className="cr">{pkg.cr}</div>
          <div className="per">{pkg.per}</div>
          <ul>
            {pkg.features.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
          <a
            href="#"
            className={`btn${pkg.featured ? '' : ' ghost'}`}
            onClick={(e) => {
              e.preventDefault();
              if (pkg.id === 'consumo') {
                toast.info('Pacote personalizado — fale com a gente');
                return;
              }
              setCheckoutPkg(pkg.id);
            }}
          >
            {pkg.featured ? 'Mais escolhido' : pkg.name === 'Pré-Pago' ? 'Começar agora' : 'Assinar'}
          </a>
        </div>
      ))}
      </div>
      {checkoutPkg && <PixCheckoutModal productId={checkoutPkg} onClose={() => setCheckoutPkg(null)} />}
    </>
  );
};